var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2065 1.63397C11.9402 0.147478 14.0598 0.147481 14.7935 1.63397L17.2369 6.58498C17.5283 7.17527 18.0914 7.58441 18.7428 7.67906L24.2066 8.47299C25.847 8.71136 26.502 10.7273 25.315 11.8844L21.3614 15.7382C20.89 16.1977 20.6749 16.8597 20.7862 17.5085L21.7195 22.9502C21.9997 24.584 20.2849 25.8299 18.8176 25.0585L13.9307 22.4893C13.348 22.183 12.652 22.183 12.0693 22.4893L7.18238 25.0585C5.71512 25.8299 4.00026 24.584 4.28048 22.9501L5.2138 17.5085C5.32508 16.8597 5.10998 16.1977 4.63861 15.7382L0.684993 11.8844C-0.502041 10.7273 0.152981 8.71136 1.79342 8.47299L7.25718 7.67906C7.90861 7.58441 8.47174 7.17527 8.76306 6.58498L11.2065 1.63397Z",
    fill: "#FFB800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/EmptyStar.2338cc21cd5f42629535476c5f45b7c9.svg";
export { ForwardRef as ReactComponent };